"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgChipOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M21 11H11v10h10zm-2 8h-6v-6h6z" }),
        React.createElement("path", { d: "M30 13v-2h-4V6h-5V2h-2v4h-6V2h-2v4H6v5H2v2h4v6H2v2h4v5h5v4h2v-4h6v4h2v-4h5v-5h4v-2h-4v-6zm-6 11H8V8h16z" })));
}
exports.default = SvgChipOutline;
//# sourceMappingURL=ChipOutline.js.map